import script from "./smart-journal.vue?vue&type=script&setup=true&lang=ts"
export * from "./smart-journal.vue?vue&type=script&setup=true&lang=ts"

import "./smart-journal.vue?vue&type=style&index=0&id=6581412e&lang=less"

const __exports__ = script;

export default __exports__